export const CREATE_ADMIN_CUSTOM_FORM_VERSION_HISTORY = "CREATE_ADMIN_CUSTOM_FORM_VERSION_HISTORY";   
export const RETRIEVE_ADMIN_CUSTOM_FORM_VERSION_HISTORY = "RETRIEVE_ADMIN_CUSTOM_FORM_VERSION_HISTORY";
export const RETRIEVESINGLE_ADMIN_CUSTOM_FORM_VERSION_HISTORY = "RETRIEVESINGLE_ADMIN_CUSTOM_FORM_VERSION_HISTORY";
export const UPDATE_ADMIN_CUSTOM_FORM_VERSION_HISTORY = "UPDATE_ADMIN_CUSTOM_FORM_VERSION_HISTORY";   
export const DELETE_ADMIN_CUSTOM_FORM_VERSION_HISTORY = "DELETE_ADMIN_CUSTOM_FORM_VERSION_HISTORY";   
